<template>
  <v-sheet
    v-if="data"
    :id="'onePage[' + pageID + ']'"
    v-resize="pageResizer"
    :class="isSmallPage ? 'small-page' : ''"
    style="position: relative"
  >
    <!-- 打印只支持亮色模式 
        ($vuetify.theme.dark ? 'theme--dark ' : 'theme--light ') -->
    <div
      class="v-data-table v-data-table--dense print-layout theme--light"
      :class="
        (isDotMatrixPrinter ? 'dot-matrix-printer' : '') +
        getFontSize +
        isPageBreak
      "
    >
      <div class="v-data-table__wrapper">
        <table v-if="!realFormater.settings.table_head_repetitive">
          <thead class="v-data-table-header table-header">
            <tr
              v-if="
                (realFormater.page_header_left &&
                  realFormater.page_header_left.length > 0) ||
                (realFormater.page_header_right &&
                  realFormater.page_header_right.length > 0)
              "
            >
              <td class="px-1 py-0 ma-0">
                <v-row no-gutters>
                  <v-col
                    v-for="(item, idx) in realFormater.page_header_left"
                    :key="idx + '_header_left'"
                    :cols="item.cols"
                    class="text-left"
                    :class="item.class"
                    :style="item.style"
                  >
                    {{ item.display_text }}
                    {{ $t("Global.colon") }}
                    {{ $printUtils.getValue(data, item) }}
                  </v-col>
                  <v-spacer />
                  <v-col
                    v-for="(item, idx) in realFormater.page_header_right"
                    :key="idx + '_header_right'"
                    :cols="item.cols"
                    class="text-right"
                    :class="item.class"
                    :style="item.style"
                  >
                    {{ item.display_text }}
                    {{ $t("Global.colon") }}
                    {{ $printUtils.getValue(data, item) }}
                  </v-col>
                </v-row>
              </td>
            </tr>
            <tr>
              <td class="px-1 py-0 ma-0">
                <PrintHeader :formater="realFormater" :data="data" />
              </td>
            </tr>
          </thead>
        </table>

        <table>
          <thead
            class="v-data-table-header table-header"
            :id="'table-header[' + pageID + ']'"
          >
            <tr
              v-if="
                realFormater.settings.table_head_repetitive &&
                ((realFormater.page_header_left &&
                  realFormater.page_header_left.length > 0) ||
                  (realFormater.page_header_right &&
                    realFormater.page_header_right.length > 0))
              "
            >
              <td :colspan="fullspan" class="px-1 py-0 ma-0">
                <v-row no-gutters>
                  <v-col
                    v-for="(item, idx) in realFormater.page_header_left"
                    :key="idx + '_header_left'"
                    :cols="item.cols"
                    class="text-left"
                    :class="item.class"
                    :style="item.style"
                  >
                    <v-img
                      :src="$printUtils.getValue(data, item)"
                      v-if="item.imgField"
                      :max-width="item.maxWidth?item.maxWidth:'100'"
                    >
                    </v-img>

                    <span v-else>
                      {{ item.display_text }}
                      {{ $t("Global.colon") }}
                      {{ $printUtils.getValue(data, item) }}
                    </span>
                  </v-col>
                  <v-spacer />
                  <v-col
                    v-for="(item, idx) in realFormater.page_header_right"
                    :key="idx + '_header_right'"
                    :cols="item.cols"
                    class="text-right"
                    :class="
                      !realFormater.settings.hide_page_counter &&
                      supportBrowser == 1 &&
                      pageInnerHeight >= 500
                        ? 'header-right ' + item.class
                        : item.class
                    "
                    :style="item.style"
                  >
                    {{ item.display_text }}
                    {{ $t("Global.colon") }}
                    {{ $printUtils.getValue(data, item) }}
                  </v-col>
                  <span
                    :class="
                      !realFormater.settings.hide_page_counter &&
                      supportBrowser == 1 &&
                      pageInnerHeight >= 500
                        ? 'support-page-counter'
                        : ''
                    "
                    class="page-counter-sample"
                    style="color: black !important"
                    :style="
                      isSmallPage ? 'font-size: 0.55rem;' : 'font-size: 0.8rem;'
                    "
                    >{{ $t("$print.pageText", [1, pages.length]) }}</span
                  >
                </v-row>
              </td>
            </tr>
            <span
              :class="
                realFormater.settings.table_head_repetitive &&
                !realFormater.settings.hide_page_counter &&
                supportBrowser == 1 &&
                pageInnerHeight >= 500
                  ? 'support-page-counter'
                  : ''
              "
              class="page-counter"
              v-for="page in pages"
              :key="page.page + '_page_counter'"
              style="position: absolute; color: black !important"
              :style="
                'top: ' +
                page.offset +
                'px;' +
                (isSmallPage
                  ? 'padding-top: 0px; font-size: 0.55rem;'
                  : 'padding-top: 4px; font-size: 0.8rem;') +
                (isDotMatrixPrinter ? ' right: 34px;' : ' right: 4px;')
              "
              >{{ $t("$print.pageText", [page.page, pages.length]) }}</span
            >
            <tr v-if="realFormater.settings.table_head_repetitive">
              <td :colspan="fullspan" class="px-1 py-0 ma-0">
                <PrintHeader :formater="realFormater" :data="data" />
              </td>
            </tr>
            <tr>
              <th :colspan="fullspan" style="height: 0" />
            </tr>
            <tr>
              <th
                v-if="realFormater.settings.table_idx"
                role="columnheader"
                scope="col"
                :aria-label="$t('Print.idx')"
                class="text-center px-1"
              >
                <span>{{ $t("Print.idx") }}</span>
              </th>
              <th
                v-for="(column, idx) in realFormater.columns"
                :key="idx + '_column'"
                role="columnheader"
                scope="col"
                :aria-label="column.display_text"
                class="text-center px-1"
                :style="column.style"
              >
                {{ column.display_text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(detail, detailIdx) in $printUtils.getField(
                data,
                realFormater.detail_key
              )"
            >
              <tr
                v-if="
                  realFormater.group_column &&
                  !realFormater.group_column.hide &&
                  (detailIdx == 0 ||
                    $printUtils.getValue(detail, realFormater.group_column) !=
                      $printUtils.getValue(
                        $printUtils.getField(data, realFormater.detail_key)[
                          detailIdx - 1
                        ],
                        realFormater.group_column
                      ))
                "
                :key="detailIdx + '_group'"
              >
                <th
                  :colspan="fullspan"
                  class="px-1"
                  :style="realFormater.group_column.style"
                >
                  <span v-if="realFormater.group_column.display_text">
                    {{ realFormater.group_column.display_text }}
                  </span>
                  <span
                    v-if="
                      realFormater.group_column.display_text &&
                      realFormater.group_column.field
                    "
                  >
                    {{ $t("Global.colon") }}
                  </span>
                  {{ $printUtils.getValue(detail, realFormater.group_column) }}
                </th>
              </tr>
              <tr
                v-if="
                  realFormater.prepend_columns &&
                  realFormater.prepend_columns.length > 0
                "
                :key="detailIdx + '_pre'"
              >
                <td :colspan="fullspan" class="px-1">
                  <v-row no-gutters>
                    <v-col
                      v-for="(column, idx) in realFormater.prepend_columns"
                      :key="idx"
                      :cols="column.cols"
                      :style="column.style"
                    >
                      <span v-if="column.display_text">
                        {{ column.display_text }}
                      </span>
                      <span v-if="column.display_text && column.field">
                        {{ $t("Global.colon") }}
                      </span>
                      {{ $printUtils.getValue(detail, column) }}
                    </v-col>
                  </v-row>
                </td>
              </tr>
              <tr :key="detailIdx + '_detail'">
                <td v-if="realFormater.settings.table_idx" class="text-center">
                  {{ detailIdx + 1 }}
                </td>
                <td
                  v-for="(column, idx) in realFormater.columns"
                  :key="idx + '_detail_column'"
                  class="px-1"
                  :class="column.class"
                  :style="column.style"
                >
                  <span v-if="column.obj_type && column.obj_type != ''">
                    {{ $printUtils.getValue(data, column) }}
                  </span>
                  <span v-else>
                    {{ $printUtils.getValue(detail, column) }}
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  realFormater.expand_columns &&
                  realFormater.expand_columns.length > 0
                "
                :key="detailIdx + '_exp'"
                class="expand-row"
              >
                <td v-if="realFormater.settings.table_idx"></td>
                <td :colspan="fullspan" class="px-1">
                  <v-row no-gutters>
                    <v-col
                      v-for="(column, idx) in realFormater.expand_columns"
                      :key="idx + '_expand_column'"
                      :cols="column.cols"
                      :style="column.style"
                    >
                      {{ column.display_text }}
                      {{ $t("Global.colon") }}
                      {{ $printUtils.getValue(detail, column) }}
                    </v-col>
                  </v-row>
                </td>
              </tr>
              <tr
                v-if="
                  realFormater.group_sum_columns &&
                  realFormater.group_sum_columns.length > 0 &&
                  (detailIdx + 1 ==
                    $printUtils.getField(data, realFormater.detail_key)
                      .length ||
                    $printUtils.getValue(detail, realFormater.group_column) !=
                      $printUtils.getValue(
                        $printUtils.getField(data, realFormater.detail_key)[
                          detailIdx + 1
                        ],
                        realFormater.group_column
                      ))
                "
                class="sum-row"
                :key="detailIdx + '_group_sum'"
              >
                <td
                  v-for="(column, idx) in realFormater.group_sum_columns"
                  :key="idx + '_group_sum_column'"
                  :colspan="column.colspan"
                  :class="
                    (idx == 0 ? ($vuetify.rtl ? 'ps-4-rtl ' : 'ps-4 ') : '') +
                    column.class
                  "
                  :style="column.style"
                >
                  <span v-if="column.display_text">
                    {{ column.display_text }}
                  </span>
                  <span v-if="column.display_text && column.field">
                    {{ $t("Global.colon") }}
                  </span>
                  {{ $printUtils.getValue(detail, column) }}
                </td>
              </tr>
              <tr
                v-if="
                  realFormater.group_sum_two_columns &&
                  realFormater.group_sum_two_columns.length > 0 &&
                  (detailIdx + 1 ==
                    $printUtils.getField(data, realFormater.detail_key)
                      .length ||
                    $printUtils.getValue(detail, realFormater.group_column) !=
                      $printUtils.getValue(
                        $printUtils.getField(data, realFormater.detail_key)[
                          detailIdx + 1
                        ],
                        realFormater.group_column
                      ))
                "
                class="sum-row"
                :key="detailIdx + '_group_sum_two'"
              >
                <td
                  v-for="(column, idx) in realFormater.group_sum_two_columns"
                  :key="idx + '_group_sum_two_column'"
                  :colspan="column.colspan"
                  :class="
                    (idx == 0 ? ($vuetify.rtl ? 'ps-4-rtl ' : 'ps-4 ') : '') +
                    column.class
                  "
                  :style="column.style"
                >
                  <span v-if="column.display_text">
                    {{ column.display_text }}
                  </span>
                  <span v-if="column.display_text && column.field">
                    {{ $t("Global.colon") }}
                  </span>
                  {{ $printUtils.getValue(detail, column) }}
                </td>
              </tr>
            </template>
            <template
              v-if="
                realFormater.sum_columns && realFormater.sum_columns.length > 0
              "
            >
              <tr class="sum-row">
                <td
                  v-for="(column, idx) in realFormater.sum_columns"
                  :key="idx + '_sum_column'"
                  :colspan="column.colspan"
                  :class="
                    (idx == 0 ? ($vuetify.rtl ? 'ps-4-rtl ' : 'ps-4 ') : '') +
                    column.class
                  "
                  :style="column.style"
                >
                  <span v-if="column.display_text">
                    {{ column.display_text }}
                  </span>
                  <span v-if="column.display_text && column.field">
                    {{ $t("Global.colon") }}
                  </span>
                  {{ $printUtils.getValue(data, column) }}
                </td>
              </tr>
            </template>
            <tr
              class="footer-row"
              v-if="realFormater.footers && realFormater.footers.length > 0"
            >
              <td :colspan="fullspan">
                <PrintFooter :footerRows="realFormater.footers" :data="data" />
              </td>
            </tr>
            <tr
              class="table-footer-row"
              v-if="
                realFormater.table_footers &&
                realFormater.table_footers.length > 0
              "
            >
              <td :colspan="fullspan">
                <PrintFooter
                  :footerRows="realFormater.table_footers"
                  :data="data"
                />
              </td>
            </tr>
          </tbody>
          <tfoot
            class="v-data-table-footer"
            :id="'page-footer[' + pageID + ']'"
          >
            <template
              v-if="
                realFormater.page_footers &&
                realFormater.page_footers.length > 0
              "
            >
              <tr class="page-footer-row">
                <td :colspan="fullspan">
                  <PrintFooter
                    :footerRows="realFormater.page_footers"
                    :data="data"
                  />
                </td>
              </tr>
            </template>
          </tfoot>
        </table>
      </div>
    </div>
    <v-btn
      v-if="showSinglePrint"
      small
      outlined
      color="grey"
      class="hidden-print me-2"
      v-print="'#onePage[' + pageID + ']'"
      style="position: absolute; top: 0; right: 0"
    >
      <v-icon x-small class="pe-1">fa-print</v-icon>
      {{ $t("Print.singlePrint") }}
    </v-btn>
  </v-sheet>
</template>

<style scoped>
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.ps-4 {
  padding-left: 16px !important;
}
.ps-4-rtl {
  padding-right: 16px !important;
}
.ma-0 {
  margin: 0 !important;
}
.v-data-table.print-layout div {
  color: black !important;
  font-size: 0.8rem;
}
.small-page .v-data-table.print-layout div {
  color: black !important;
  font-size: 0.55rem;
}
.v-data-table.print-layout table tr th {
  color: black !important;
  font-size: 0.8rem;
  height: 27px;
}
.small-page .v-data-table.print-layout table tr th {
  color: black !important;
  font-size: 0.55rem;
  height: 14x;
}
.v-data-table.print-layout table tr td {
  color: black !important;
  font-size: 0.8rem;
  height: 27px;
}
.small-page .v-data-table.print-layout table tr td {
  color: black !important;
  font-size: 0.55rem;
  height: 14px;
}
/* .print-layout table {
  border-spacing: 0;
} */
/* ↑可能是部署后需要v-data-table样式才正常的秘密 */
.v-data-table.print-layout table tr th {
  border-left: 0 !important;
  border-bottom: thin solid black !important;
  border-right: thin solid black !important;
  border-top: 0 !important;
}
.v-data-table.print-layout table tr th {
  border-left: thin solid black !important;
  border-right: thin solid black !important;
}
.v-data-table.print-layout table tr th:not(:first-child) {
  border-left: 0 !important;
}
.v-data-table.print-layout table tr td {
  border-left: thin solid black !important;
  border-right: thin solid black !important;
}
.v-data-table.print-layout table tr td:not(:first-child) {
  border-left: 0 !important;
}
.v-data-table.print-layout table tr.expand-row td:not(:last-child) {
  border-right: 0 !important;
}
.v-data-table.print-layout table thead tr td {
  border: 0 !important;
}
.v-data-table.print-layout table tbody tr td:is(:first-child) {
  border-left: thin solid black !important;
}
.v-data-table.print-layout table tfoot tr td:is(:first-child) {
  border-left: thin solid black !important;
}
.v-data-table.print-layout table tr td {
  border-bottom: thin solid black !important;
}
.v-data-table.print-layout table tr.sum-row td:not(:last-child) {
  border-right: 0 !important;
}
/* .v-data-table.print-layout table tr:not(:last-child).footer-row td {
  border-bottom: 0 !important;
} */
.v-data-table.print-layout table tbody tr.table-footer-row td {
  border: 0 !important;
}
.v-data-table.print-layout table tfoot tr.page-footer-row td {
  border: 0 !important;
}
.font-sizeS table tr td {
  font-size: 0.8rem !important;
}
.font-sizeS table tr th {
  font-size: 0.8rem !important;
}
.font-sizeM table tr td {
  font-size: 1rem !important;
}
.font-sizeM table tr th {
  font-size: 1rem !important;
}
.font-sizeB table tr td {
  font-size: 1.2rem !important;
}
.font-sizeB table tr th {
  font-size: 1.2rem !important;
}
</style>
<style>
.page-counter {
  display: none !important;
}
.page-counter-sample {
  padding-left: 16px;
  display: none !important;
}
.support-page-counter.page-counter {
  display: none !important;
}
.support-page-counter.page-counter-sample {
  display: block !important;
}
.print-layout {
  padding: 18px;
  /* ↑模拟打印模式下页面宽度的显示情况 */
}
.dot-matrix-printer.print-layout {
  padding-left: 48px;
  padding-right: 48px;
  /* ↑模拟针式打印机打印模式下页面宽度的显示情况 */
}
.print-layout-container {
  width: auto;
  /* ↑实际在外层App.vue中控制router-view的element.style */
}
@media print {
  .header-right {
    padding-right: 108px !important;
  }
  .support-page-counter.page-counter {
    display: block !important;
  }
  .support-page-counter.page-counter-sample {
    display: none !important;
  }
  .print-layout {
    padding: 0px;
    /* position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto; */
  }
  .page-break {
    page-break-after: always;
  }
  .dot-matrix-printer.print-layout {
    padding-left: 30px !important;
    padding-right: 30px !important;
    /* ↑针式打印机打印时避开孔洞 */
  }
  @page {
    /* background-color: red !important; */
    size: auto;
    margin: 18px;
    /* ↑打印时的默认页边距，要修改样式的话记得连带修改下面的pagePadding以免页码计算出问题 */
  }
  .print-layout-container {
    width: 100% !important;
  }
  .v-data-table.print-layout table thead {
    display: table-header-group !important;
  }
  .v-data-table.print-layout table tfoot {
    display: table-footer-group !important;
  }
  .v-data-table.print-layout table tbody {
    display: table-row-group !important;
  }
}
</style>

<script>
const pagePadding = 18;
// ↑页面默认padding，18px为5mm，留出了出血线宽度（注意，20px就会被浏览器成5.5cm了，对不齐）
// ↑浏览器打印设置页边距选择“默认”时会自动应用此设置，其他选项会覆盖。页码计算默认设置下保证显示效果。
// ↑页码暂且只在Chrome系浏览器下显示，FireFox因为打印盒子模型问题不适配
import i18n from "@/i18n";
import { mapState } from "vuex";
import PrintHeader from "@/components/plugins/print/PrintHeader";
import PrintFooter from "@/components/plugins/print/PrintFooter";

export default {
  components: {
    PrintHeader,
    PrintFooter,
  },

  props: {
    pageID: [String, Number],
    formater: Object,
    data: Object,
    dataFormaterKey: String,
    showSinglePrint: Boolean,
    lastPage: Boolean, //是否最后一页
  },

  data: () => ({
    pageOptions: i18n.t("$print.pageOptions"),
    fontSizeOptions: i18n.t("$print.fontSizeOptions"),
    lastPageOption: null,
    pages: [],
    tableHeight: 0,
    headerHeight: 0,
    footerHeight: 0,
    pageInnerHeight: 0,
  }),

  computed: {
    realFormater() {
      var real =
        this.data && this.dataFormaterKey
          ? this.$printUtils.getField(this.data, this.dataFormaterKey)
          : null;
      return real ? real : this.formater;
    },
    fullspan() {
      return (
        this.formater.columns.length +
        (this.formater.settings.table_idx ? 1 : 0)
      );
    },
    isSmallPage() {
      return this.pageOptions[this.printPageSize].smallPage;
    },
    isDotMatrixPrinter() {
      return this.pageOptions[this.printPageSize].dotMatrixPrinter;
    },
    getFontSize() {
      return this.fontSizeOptions[this.printFontSize].class;
    },
    isPageBreak() {
      return typeof this.pageID == "undefined" ||
        this.pageID == undefined ||
        this.lastPage
        ? ""
        : " page-break";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "supportBrowser",
      "printPageSize",
      "printMode",
      "printFontSize",
    ]),
    // ↑ supportBrowser==1为支持打印分页页码的浏览器（chrome、Edge等），0为未判定，其他值为不支持
  },

  mounted() {
    if (!this.supportBrowser) {
      //supportBrowser==1为支持打印分页页码的浏览器（chrome、Edge等），0为未判定，其他值为不支持；只在未判定时做一次判断
      var ua = window.navigator.userAgent;
      var supportBrowser =
        ua.indexOf("Chrome/") >= 0 || ua.indexOf("Edg/") >= 0;
      this.$store.commit("supportBrowser", supportBrowser ? 1 : 2);
    }
  },

  watch: {
    printPageSize: {
      // immediate: true,
      handler() {
        if (
          !this.lastPageOption ||
          this.lastPageOption.smallPage ==
            this.pageOptions[this.printPageSize].smallPage
        ) {
          this.pageResizer();
        } else {
          location.reload();
        }
      },
    },
  },

  methods: {
    pageResizer() {
      if (
        !this.formater ||
        !this.formater.settings ||
        !this.formater.settings.table_head_repetitive
      )
        return; //不重复表头的话不需要做计算
      this.tableHeight =
        document.getElementById("onePage[" + this.pageID + "]").scrollHeight -
        pagePadding * 2;
      this.headerHeight = document.getElementById(
        "table-header[" + this.pageID + "]"
      ).scrollHeight;
      this.footerHeight = document.getElementById(
        "page-footer[" + this.pageID + "]"
      ).scrollHeight;
      this.lastPageOption = this.pageOptions[this.printPageSize];
      this.pageInnerHeight =
        this.pageOptions[this.printPageSize].height - pagePadding * 2;
      // 根据页面设置判断高度，计算重复表头和页尾增加的高度和padding的影响
      var pageCount = Math.ceil(
        (this.tableHeight - this.headerHeight - this.footerHeight) /
          (this.pageInnerHeight - this.headerHeight - this.footerHeight)
      );
      this.pages = [];
      for (var i = 0; i < pageCount; i++) {
        this.pages.push({
          page: i + 1,
          offset: i * this.pageInnerHeight - i, // -i is magic!
        });
      }
    },
  },
}; //596
</script>